import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SearchDataService {
    
    private dataSignal = signal<any | null>(null);
    private searchedSignal = signal<boolean>(false);

    setData(data: any):void {
        this.dataSignal.set(data);
        this.searchedSignal.set(true);
    }

    getData() {
        return this.dataSignal();
    }

    hasData(): boolean {
        const data = this.dataSignal();
        let res: boolean = false;
        if (!data) {
            res = false;
        }    
        else if (Array.isArray(data)) {
            res = data.length > 0;
        }        
        else if (data.results && Array.isArray(data.results)) {
            res = data.results.length > 0;
        }

        return res;
    }

    wasSearched(): boolean {
        return this.searchedSignal();
    }
}
